<template>
    <!-- class="heightMAX" -->
    <div class="xePeekCard kbet-custom-reset heightMAX" :class="{ 'is-overview-compact': isOverviewCompact }" :style="{ overflow: 'hidden' }">
        <drop @dragover="handleBodyDragOver(...arguments)" @drop="handleBodyDrop(...arguments)" class="heightMAX">
            <div class="kbet-custom-reset">
                <div class="rounded kbet-widget-energy v1 heightMAX">
                    <!-- :style="{backgroundColor: this.widget.card.backgroundColor}" -->
                    <p class="title rounded-top">
                        {{ $t(widget.title) }}
                    </p>
                    <div class="energy-usage-area cardHeight">
                        <div class="real-time-area" :style="{ width: shouldShowInfo ? '60%' : '100%' }">
                            <div class="real-time">
                                <div class="graph-area">
                                    <gauge-chart
                                        ref="gaugeChart"
                                        class="svg-box"
                                        :needleData="peakData.currentPeak[0]"
                                        :maxData="peakData.contractPeak[0]"
                                        :unit="peakData.currentPeak[1]"
                                        :color="widget.gaugeColor"
                                        :size="peekSize"
                                        :showInfo="shouldShowInfo"
                                        :width="width"
                                        :height="height"
                                        :peakData="peakData"
                                        :compact="isOverviewCompact"
                                    >
                                    </gauge-chart>
                                </div>
                            </div>
                        </div>

                        <div v-if="shouldShowInfo" class="divider-line">
                            <span class="hidden">{{ $t("구분선") }}</span>
                        </div>

                        <div v-if="shouldShowInfo" class="today-peak">
                            <dl class="real-time-data peak-v1">
                                <dt :style="{ fontSize: isOverviewCompact ? '10px' : '12px' }">
                                    {{ $t("오늘의 피크") }} ({{ peakData.maxPeakTime }})
                                </dt>
                                <dd>
                                    <strong class="font-roboto-slab">{{
                                        Number(peakData.maxPeak[0]).toLocaleString()
                                    }}</strong>
                                    <span>{{ peakData.maxPeak[1] }}</span>
                                </dd>
                            </dl>
                            <ul class="peak-v2">
                                <li>
                                    <div class="peak-content" :style="{ fontSize: isOverviewCompact ? '10px' : '12px' }">
                                        <dt>{{ $t("계약 전력 ") }}:</dt>
                                        <div>
                                            <strong class="font-roboto-slab">
                                                {{ Number(peakData.contractPeak[0]).toLocaleString() }}</strong
                                            >
                                            <span> {{ peakData.contractPeak[1] }}</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="peak-content" :style="{ fontSize: isOverviewCompact ? '10px' : '12px' }">
                                        <dt>{{ $t("올해 피크") }} :</dt>
                                        <div>
                                            <strong class="font-roboto-slab">{{
                                                Number(peakData.maxPeakCurrentYear[0]).toLocaleString()
                                            }}</strong>
                                            <span>{{ " " + peakData.maxPeakCurrentYear[1] }}</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="peak-content" :style="{ fontSize: isOverviewCompact ? '10px' : '12px' }">
                                        <dt>{{ $t("작년 피크") }} :</dt>
                                        <div>
                                            <strong class="font-roboto-slab">
                                                {{ Number(peakData.maxPeakPrevYear[0]).toLocaleString() }}
                                            </strong>
                                            <span> {{ peakData.maxPeakPrevYear[1] }}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </drop>

        <b-modal
            ref="modalSetting"
            size="lg"
            :title="`${$t('설정')} - ${$t('실시간 전력현황')}`"
            body-class="p-t-0 p-b-0"
            hide-footer
        >
            <peek-card-setting
                :initSetting="peekCardSetting"
                @on-modal-cancel="onModalCancel"
                @on-modal-ok="onModalOK"
            />
        </b-modal>
    </div>
</template>

<script>
import xeBaseWidget from "@src/views/widget/v1/common/xeBaseWidget.js";
import GaugeChart from "@components/vue-chartjs/Charts/gaugeChart.vue";
import PeekCardSetting from "./setting/xePeekSetting";
import utils from "@src/views/widget/v1/common/xeBaseUtils.js";

export default {
    name: "xePeekCard",
    extends: xeBaseWidget,
    components: {
        GaugeChart,
        PeekCardSetting,
    },
    props: ["width", "height"],
    data() {
        return {
            peakData: {
                currentPeak: ["1", ""],
                maxPeak: ["1", ""],
                maxPeakTime: "1",
                contractPeak: ["1", ""],
                maxPeakPrevYear: ["1", ""],
                maxPeakCurrentYear: ["1", ""],
            },
            testPeak: 100,
            themeColor: global.xe.parseBool(localStorage.contentInverse)
                ? require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").dark
                : require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").light,
        };
    },
    computed: {
        shouldShowInfo() {
            return this.width > 4;
        },
        peekSize() {
            if (!this.width || !this.height) {
                return;
            }
            let size = Number(this.width) * Number(this.height);
            return size;
        },
        peekCardSetting() {
            return JSON.parse(JSON.stringify(this.widget));
        },
        master() {
            return this.$store.getters.master;
        },
    },
    watch: {
        isOverviewCompact() {
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    if (this.$refs.gaugeChart?.renderChart) {
                        this.$refs.gaugeChart.renderChart();
                    } else if (this.$refs.gaugeChart?.resizeChart) {
                        this.$refs.gaugeChart.resizeChart();
                    }
                });
            });
        },
    },

    created() {
        if (!this.widget.bgIcon) {
            this.widget.bgIcon = "material flash_on";
        }
        if (!this.widget.moved) {
            this.widget.moved = false;
        }
        if (!this.widget.zoneIdx) {
            this.widget.zoneIdx = 1;
        }
        if (!this.widget.objects) {
            this.widget.objects = {
                main: {
                    label: "",
                    addition: {
                        afterAction: "",
                        afterBind: "",
                        isPercentage: true,
                        fixed: 0,
                    },
                    tail: "",
                    point: "",
                    value: 0,
                    self: { type: 0, sTi: "", eTi: "" },
                },
                bottom: {
                    label: "",
                    addition: {
                        afterAction: "",
                        afterBind: "",
                        isPercentage: false,
                        fixed: 0,
                    },
                    tail: "",
                    point: "",
                    value: 0,
                    self: { type: 0, sTi: "", eTi: "" },
                },
                series: { backgroundColor: "" },
            };
        }
        if (!this.widget.card) {
            this.widget.card = {
                colorOpens: false,
                titleColor: "#000000FF",
                titleFontSize: 14,
                backgroundColor: "#3F3F3F",
                style: {
                    main: {
                        fontSize: "30",
                        fontWeight: "600",
                        fontColor: "#000000FF",
                        unitSize: "15",
                        unitColor: "#000000FF",
                        iconColor: "#FFFFFFFF",
                        textAlign: "center",
                    },
                    bottom: {
                        fontSize: "15",
                        fontWeight: "400",
                        fontColor: "#000000FF",
                        unitSize: "15",
                        unitColor: "#000000FF",
                        textAlign: "left",
                    },
                },
            };
        }
        if (!this.widget.title) {
            this.widget.title = "실시간 전력피크";
        }
    },
    mounted() {
        let lodCard = document.getElementsByClassName("xePeekCard");

        for (let i = 0; i < lodCard.length; i++) {
            lodCard[i].parentNode.style.height = "100%";
        }

        let svgs = document.getElementsByClassName("vue-gauge-item");

        for (let i = 0; i < svgs.length; i++) {
            if (svgs[i].childNodes[0] && svgs[i].childNodes[0].className.baseVal !== "svg-box-content") {
                svgs[i].childNodes[0].className.baseVal = svgs[i].childNodes[0].className.baseVal + "svg-box-content";
            }
        }

        let svgAttri = document.getElementsByTagName("svg");
        for (let i = 0; i < svgAttri.length; i++) {
            // if (svgAttri[i].width !== "100%" && svgAttri[i].height !== "100%") {
            //   svgAttri[i].removeAttribute("width");
            //   svgAttri[i].removeAttribute("height");
            //   svgAttri[i].setAttribute("width", "100%");
            //   svgAttri[i].setAttribute("height", "100%");
            //   svgAttri[i].setAttribute("viewBox", "0, 0, 250, 170");
            // }
        }
    },
    methods: {
        initSetting() {
            this.isPanelExpand = false;
        },
        applyData(data) {
            // this.peakData = data;
            // data = {
            //   contractPeak: "50 kw",
            //   currentPeak: "123456789.0 kW",
            //   maxPeakTime: "07:15",
            //   maxPeak: "4 kW",
            //   maxPeakPrevYear: "56.6 kW",
            //   maxPeakCurrentYear: "33.6 kW",
            // }

            // index[0] : value
            // index[1] : unit (kw)
            this.peakData = {
                currentPeak: data.currentPeak !== null ? data.currentPeak.split(" ") : ["-", ""],
                maxPeak: data.maxPeak !== null ? data.maxPeak.split(" ") : ["-", ""],
                maxPeakTime: data.maxPeakTime,
                contractPeak: data.contractPeak !== null ? data.contractPeak.split(" ") : ["-", ""],
                maxPeakPrevYear: data.maxPeakPrevYear !== null ? data.maxPeakPrevYear.split(" ") : ["-", ""],
                maxPeakCurrentYear: data.maxPeakCurrentYear !== null ? data.maxPeakCurrentYear.split(" ") : ["-", ""],
            };

            // this.peakData.maxPeakPrevYear = "342 kw";
            // this.peakData.maxPeakCurrentYear = "2,3312 kw";
            this.data = data;
        },
        getCond(logs, cond) {
            let rtnLogs = null;

            // 일자형식 스크립트 실행
            function runTi(type, ti) {
                let fn = new Function("now", "baseline", "compare", "type", "return " + ti);
                let dt = fn(new Date(), type);

                return dt.normalize(type);
            }

            rtnLogs = logs.filter(
                (log) =>
                    log.type == cond.type &&
                    log.sDt == runTi(cond.type, cond.sTi) &&
                    log.eDt == runTi(cond.type, cond.eTi) &&
                    log.points[cond.point]
            );

            return rtnLogs;
        },
        bindCard(log, card) {
            let ptVals = [];

            if (Array.isArray(log)) ptVals = log[0].points[card.point];
            else ptVals = log.points[card.point];

            ptVals = utils.onAfterAction(card.point, ptVals, card.addition.afterAction); // 배열반환

            let val = utils.onAfterBind(card.point, ptVals, card.addition ? card.addition.afterBind : null); // 값반환

            card.value = val;
        },
        handleDropPoint(label, arg) {
            this.widget.title = arg.item.title;
            if (label == "main") {
                this.widget.title = arg.item.title;
                this.widget.objects.main = {
                    label: "",
                    addition: { afterAction: "", afterBind: "Last", isPercentage: false },
                    tail: "",
                    point: arg.item.ptAddr,
                    value: 0,
                };

                // "main"  : { "label":"", "afterBind": "Last", "tail": "kWh", "point": "084000001_0000_0000_VLI_00000001" },
            } else {
                // bottom
                this.widget.title = arg.item.title;
                this.widget.objects.bottom = {
                    label: "",
                    addition: { afterAction: "", afterBind: "Last", isPercentage: false },
                    tail: "",
                    point: arg.item.ptAddr,
                    value: 0,
                };
            }
        },

        // 드래그
        // handleDropPoint(transfer) {
        //   if (this.$err(transfer)) return;

        //   this.widget.title = transfer.item.title;
        //   this.widget.objects.main = { afterBind: "Last", tail: "", point: transfer.item.ptAddr, value: 0 };
        // },
    },
};
</script>

<style scoped>
.peak-v2 {
    width: 90%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: stretch;
    gap: 5px;
}
.peak-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
/* .svg-box {
  width: 100%;
  height: 100%;
  position: relative;
} */
.energy-usage-area {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100% !important;
}

.real-time-area {
    height: 100%;
    /* width: 60%; */
    /* display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; */
}
.cardHeight {
    height: 100% !important;
    max-height: 100%;
    overflow: hidden;
}
.svg-box-content {
    top: 0;
    left: 0;
}
.real-time {
    width: 100% !important;
    height: 100% !important;
}
.graph-area {
    height: 100%;
}
.today-peak {
    margin-left: 12px;
}

.xePeekCard.is-overview-compact .peak-v1 strong {
    font-size: 14px;
}

.xePeekCard.is-overview-compact .peak-v1 span,
.xePeekCard.is-overview-compact .peak-content span {
    font-size: 10px;
}

.xePeekCard.is-overview-compact .today-peak {
    margin-left: 6px;
}

/* 그리드 2행에 실제 높이 할당 (auto+height:100% 순환 붕괴 방지) */
.xePeekCard.is-overview-compact ::v-deep .kbet-widget-energy.v1 {
    grid-template-rows: 28px minmax(0, 1fr) !important;
    -ms-grid-rows: 28px minmax(0, 1fr) !important;
    min-height: 0 !important;
    height: 100%;
}

.xePeekCard.is-overview-compact .energy-usage-area.cardHeight {
    height: 100% !important;
    max-height: 100% !important;
    min-height: 0 !important;
    align-self: stretch !important;
    overflow: hidden;
    padding: 0 4px;
    box-sizing: border-box;
}

.xePeekCard.is-overview-compact .real-time-area,
.xePeekCard.is-overview-compact .real-time,
.xePeekCard.is-overview-compact .graph-area {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 0;
}

.xePeekCard.is-overview-compact ::v-deep .gauge-chart-container,
.xePeekCard.is-overview-compact ::v-deep .gauge-chart {
    position: absolute;
    inset: 0;
    width: 100% !important;
    height: 100% !important;
    min-height: 0;
}
</style>
